import { BaseAction } from 'redux-actions';
import { AccountAndNetwork } from 'src/models/account';
import { MvnoTemplate } from '../api/mvnoTemplateApi';
import { DropdownItem } from '../components/ui/input/DropdownInput';
import { SimManagementError } from '../models/Errors';
import {
  ENSURE_MVNO_TEMPLATES,
  LOAD_MVNO_TEMPLATES,
  LOAD_MVNO_TEMPLATES_FAILURE,
  LOAD_MVNO_TEMPLATES_PENDING,
  LOAD_MVNO_TEMPLATES_SUCCESS,
} from './actionTypes';
import { Action, PromiseAction, RejectFunc, ResolveFunc } from './commonActions';

export function ensureMvnoTemplates(value: AccountAndNetwork): Action<AccountAndNetwork> {
  return {
    type: ENSURE_MVNO_TEMPLATES,
    payload: value,
  };
}

export function loadMvnoTemplates(
  resolve?: ResolveFunc<DropdownItem[]>,
  reject?: RejectFunc,
): PromiseAction<undefined, DropdownItem[]> {
  return {
    type: LOAD_MVNO_TEMPLATES,
    resolve,
    reject,
  };
}

export function loadMvnoTemplatesPending(): BaseAction {
  return {
    type: LOAD_MVNO_TEMPLATES_PENDING,
  };
}

export function loadMvnoTemplatesFailure(error: SimManagementError): Action<SimManagementError> {
  return {
    type: LOAD_MVNO_TEMPLATES_FAILURE,
    payload: error,
  };
}

export function loadMvnoTemplatesSuccess(items: MvnoTemplate[]): Action<MvnoTemplate[]> {
  return {
    type: LOAD_MVNO_TEMPLATES_SUCCESS,
    payload: items,
  };
}
